(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/utils/assets/javascripts/contains-correct-outcome.js') >= 0) return;  svs.modules.push('/components/pool-betting/utils/assets/javascripts/contains-correct-outcome.js');
"use strict";


const containsCorrect1X2Outcome = (selectedOutcomes, eventOutcome) => selectedOutcomes.some(selectedOutcome => (selectedOutcome === null || selectedOutcome === void 0 ? void 0 : selectedOutcome[0]) === (eventOutcome === null || eventOutcome === void 0 ? void 0 : eventOutcome[0]));
setGlobal('svs.components.poolBetting.utils.containsCorrect1X2Outcome', containsCorrect1X2Outcome);

 })(window);